import React from 'react';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './RestrictToEnterpriseContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { VillesChartContainer } from '../../../../../entity/charts/villes/VillesChartContainer';
import { VillesChart } from '../../../../../entity/charts/villes/VillesChart';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { EnhanceVilleChart } from '../../../../../entity/charts/villes/EnhanceVilleChart';
import { ChartDecisionLegend } from '../../../../../entity/charts/legend/ChartLegend';
import { Ville } from '../../../../../entity/entity.types';

type Props = {
  enterpriseId: string;
  raisonSociale: string;
  villes: Array<any>;
  url: string;
  source: string;
} & PropsFromRedux &
  UserContextType &
  WithRestrictedModalProps;

class RawVilleTab extends React.Component<Props> {
  goToPage = (source: string) => () => {
    const clickedSource = `${this.props.source}-${source}`;
    if (this.props.accessPremium) {
      window.location.href = `${this.props.url}?source=${clickedSource}`;
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  filterSearch = (source: string) => (
    wantToOpenInNewTab: boolean,
    ville: Ville | null,
  ) => {
    const clickedSource = `${this.props.source}-${source}`;
    if (this.props.accessPremium) {
      const data = {
        enterpriseId: this.props.enterpriseId,
        raisonSociale: this.props.raisonSociale,
        ville: ville ? ville.key : null,
        type: 'ville' as const,
      };
      doctrineAnalytics('Search ChartSnippetClicked', data);
      this.props.onRestrictToEnterprise(data);
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  render() {
    return (
      <div className="enterprise-snippet__panel">
        <VillesChartContainer villes={this.props.villes}>
          {({ sortedVilles }) => (
            <>
              <EnhanceVilleChart
                villes={sortedVilles}
                handleClick={this.filterSearch('villes_chart')}
              >
                {({ data, labels, handleClick }) => (
                  <VillesChart
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                  />
                )}
              </EnhanceVilleChart>
              <EnhanceVilleChart
                villes={sortedVilles}
                handleClick={this.filterSearch('villes_legend')}
              >
                {({ data, labels, handleClick, baseH }) => (
                  <ChartDecisionLegend
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                    onSeeMoreClicked={this.goToPage('villes_more_legend')}
                    baseH={baseH}
                    limit={3}
                  />
                )}
              </EnhanceVilleChart>
            </>
          )}
        </VillesChartContainer>
      </div>
    );
  }
}

export const VilleTab = Connect(withUser(withRestrictedModal(RawVilleTab)));
